export var BASKET_STATUS = function (BASKET_STATUS) {
  BASKET_STATUS["FAILED"] = "FAILED";
  BASKET_STATUS["COMPLETED"] = "COMPLETED";
  BASKET_STATUS["PROCESSING"] = "PROCESSING";
  BASKET_STATUS["OPEN"] = "OPEN";
  BASKET_STATUS["CANCELLED"] = "CANCELLED";
  BASKET_STATUS["PAY_PENDING"] = "PAY_PENDING";
  BASKET_STATUS["AMENDING"] = "AMENDING";
  BASKET_STATUS["AMENDED"] = "AMENDED";
  BASKET_STATUS["AMEND_FAILED"] = "AMEND_FAILED";
  BASKET_STATUS["PAYMENT_REQUIRED"] = "PAYMENT_REQUIRED";
  BASKET_STATUS["NOT_REQUIRED"] = "NOT_REQUIRED";
  BASKET_STATUS["SECURE_FAILED"] = "SECURE_FAILED";
  return BASKET_STATUS;
}({});